var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog-header-container",attrs:{"row":""}},[_c('div',{staticClass:"d-flex justify-space-between",attrs:{"row":""}},[_c('div',[_vm._v(_vm._s(_vm.title))]),_c('v-spacer'),_c('v-btn',{staticStyle:{"margin-top":"-6px"},attrs:{"icon":""},on:{"click":_vm.close}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }